import styled from "@emotion/styled";
import { ArrowBack } from "@mui/icons-material";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import { LanguageSelector } from "components/UI";
import { Outlet, useNavigate } from "react-router-dom";
import { useCentralStore } from "stores";

const Container = styled.div`
  display: flex;
  height: 100vh;
`;

const Content = styled.div`
  height: 100vh;
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;

  ${({ theme }) => `${theme.breakpoints.up("md")} {
    flex-basis: 50%;
  }`}
`;

export const HelpLayout = ({ hasBack = true }) => {
  return (
    <Container>
      <Content>
        <Header hasBack={hasBack} />
        <Box
          sx={{
            pb: 6,
            px: 4
          }}
        >
          <Outlet />
        </Box>
      </Content>
    </Container>
  );
};

const Header = ({ hasBack = true }) => {
  const headerTitle = useCentralStore(state => state.headerTitle);
  const headerHasBackground = useCentralStore(
    state => state.headerHasBackground
  );
  const navigate = useNavigate();

  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{
        color: "neutral.contrastText",
        backgroundColor: `${headerHasBackground ? "neutral.main" : ""}`,
        py: {
          xs: 1,
          md: 2
        },
        px: {
          xs: 2,
          md: 4
        }
      }}
    >
      <Stack direction="row" alignItems="center">
        {hasBack && (
          <IconButton aria-label="back" onClick={() => navigate(-1)}>
            <ArrowBack />
          </IconButton>
        )}
        <Typography sx={{ fontWeight: 500 }}>{headerTitle}</Typography>
      </Stack>
      <LanguageSelector />
    </Stack>
  );
};
